import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import Api from "./api";

export function loadUserGroups() {
  return async (dispatch, getState) => {
    let loading = false,
      loaded = false;
    const userGroups = getState().userProfile.userGroups;
    if (userGroups) {
      loading = userGroups.loading;
      loaded = userGroups.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_USER_PROFILE_GROUPS_STARTED });
      const userGroupsData = await dispatch(sendHttpRequest(Api.getUserGroups()));
      dispatch({ type: actionTypes.LOAD_USER_PROFILE_GROUPS_SUCCESS, payload: userGroupsData });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
